module.exports = __webpack_public_path__ + "img/d5.8955a5f2.png";